import React from 'react';
import Header from './Header';
import Footer from './Footer';
import CustomCursor from '../UI/CustomCursor';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col relative bg-off-white overflow-hidden">
      <CustomCursor />
      <Header />
      <main className="flex-grow pt-16">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
